import { useLang } from '../lib/i18n';

// Přepínač jazyka CZ / EN.
export default function LanguageToggle() {
  const [lang, setLang] = useLang();
  return (
    <div className="flex overflow-hidden rounded-md border border-zinc-300 dark:border-zinc-700 text-[11px]">
      {(['cs', 'en'] as const).map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          className={`px-1.5 py-1 ${lang === l ? 'bg-zinc-900 text-white dark:bg-zinc-100 dark:text-zinc-900' : 'text-zinc-500 hover:bg-zinc-100 dark:hover:bg-zinc-800'}`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
